(function () {
        if (window.__cartQtyGuard) return;
        window.__cartQtyGuard = true;

        const MAX_CACHE = new Map(); // line -> max (Number or Infinity)

        function isQty(i) {
          return i && i.matches('input[type="number"][name="updates[]"]');
        }
        function minOf(i) {
          return parseInt(i.min || '1', 10);
        }
        function cachedMaxOf(i) {
          const line = i.dataset.index;
          const dm = line ? MAX_CACHE.get(line) : undefined;
          return typeof dm === 'number' ? dm : Infinity;
        }
        function clamp(i, v) {
          const min = minOf(i);
          const max = cachedMaxOf(i);
          v = parseInt(v, 10);
          if (isNaN(v)) v = min;
          if (v < min) v = min;
          if (v > max) v = max;
          return v;
        }

        // scan alle Inputs und befülle Cache aus data-max
        function syncMaxCache() {
          document.querySelectorAll('input[type="number"][name="updates[]"]').forEach((i) => {
            const line = i.dataset.index;
            if (!line) return;
            const dm = parseInt(i.dataset.max || '', 10);
            if (!isNaN(dm)) MAX_CACHE.set(line, dm);
            else MAX_CACHE.set(line, Infinity);
            // Sicherheitsnetz: Browser-max komplett rausnehmen
            i.removeAttribute('max');
          });
        }

        // Live-Validierung beim Tippen (zeigt native Tooltip, kein Clamping)
        function onInput(e) {
          const i = e.target.closest('input[type="number"][name="updates[]"]');
          if (!i) return;
          const digits = i.value.replace(/\D/g, '');
          if (digits !== i.value) i.value = digits;

          if (!digits) {
            i.setCustomValidity('');
            return;
          }
          const min = minOf(i),
            max = cachedMaxOf(i),
            v = parseInt(digits, 10);
          let msg = '';
          if (isNaN(v)) msg = `Bitte eine Zahl eingeben.`;
          else if (v < min) msg = `Mindestens ${min} Stück.`;
          else if (v > max) msg = `Nur bis ${max} Stück möglich.`;
          i.setCustomValidity(msg);
          if (msg) i.reportValidity();
        }

        // Sofortprüfung auf change/blur: ungültig -> blockieren + an Grenze setzen
        function onImmediate(e) {
          const i = e.target.closest && e.target.closest('input[type="number"][name="updates[]"]');
          if (!i) return;
          const min = minOf(i),
            max = cachedMaxOf(i),
            raw = parseInt(i.value || '0', 10);

          if (!i.value || isNaN(raw) || raw < min || raw > max) {
            const v = clamp(i, raw);
            i.value = String(v);
            let msg = '';
            if (!i.value || isNaN(raw)) msg = `Bitte eine Zahl eingeben.`;
            else if (raw < min) msg = `Mindestens ${min} Stück.`;
            else if (raw > max) msg = `Nur bis ${max} Stück möglich.`;
            i.setCustomValidity(msg);
            i.reportValidity();
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();
          } else {
            i.setCustomValidity('');
          }
        }

        // Plus/Minus: 1er Schritte im Bereich + sofort change (damit dein cart.js updatet)
        function onClick(e) {
          const btn = e.target.closest('.quantity .plus, .quantity .minus');
          if (!btn) return;
          const wrap = btn.closest('.quantity');
          const i = wrap && wrap.querySelector('input[type="number"][name="updates[]"]');
          if (!i) return;

          const min = minOf(i),
            max = cachedMaxOf(i),
            step = parseInt(i.step || '1', 10) || 1;
          let v = parseInt(i.value || String(min), 10);
          if (isNaN(v)) v = min;
          v = btn.classList.contains('plus') ? Math.min(v + step, max) : Math.max(v - step, min);

          i.setCustomValidity('');
          if (String(i.value) !== String(v)) {
            i.value = String(v);
            i.dispatchEvent(new Event('change', { bubbles: true }));
          }
          e.preventDefault();
          e.stopImmediatePropagation();
        }

        // Enter im Feld unterbinden (Blur triggert change)
        function onKey(e) {
          if (e.key === 'Enter' && isQty(e.target)) {
            e.preventDefault();
            e.target.blur();
          }
        }

        // Events global, damit’s überall gilt (Cart-Seite & Drawer)
        document.addEventListener('input', onInput, true);
        document.addEventListener('change', onImmediate, true);
        document.addEventListener('blur', onImmediate, true);
        document.addEventListener('change', syncMaxCache, true); // falls neue Inputs kommen
        document.addEventListener('click', onClick, true);
        document.addEventListener('keydown', onKey, true);

        // Cache auch nach Re-Renders aktualisieren
        window.addEventListener('load', syncMaxCache);
        document.addEventListener('shopify:section:load', syncMaxCache);
        document.addEventListener('cart:refresh', syncMaxCache);
      })();